var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconShadedSphereDark = function SvgIconShadedSphereDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_shaded_sphere_dark_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    fillRule: "evenodd",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm-4.715-3.405c2.435 1.486 5.901.245 7.742-2.772 1.841-3.017 1.36-6.667-1.076-8.153C7.516.184 4.049 1.425 2.208 4.442.368 7.458.85 11.109 3.285 12.595Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    fillRule: "evenodd",
    d: "M3.284 12.592c2.436 1.486 5.902.245 7.743-2.772 1.841-3.016 1.36-6.667-1.076-8.153C7.516.181 4.049 1.422 2.208 4.44.368 7.455.85 11.106 3.284 12.592Zm-.662-4.084c.948.579 2.515-.26 3.5-1.873.984-1.613 1.013-3.39.065-3.97-.949-.578-2.516.26-3.5 1.874-.985 1.613-1.014 3.39-.065 3.969Z",
    clipRule: "evenodd",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "M6.122 6.638c-.984 1.613-2.551 2.452-3.5 1.873-.948-.579-.92-2.356.065-3.969.985-1.613 2.552-2.452 3.5-1.873.949.579.92 2.356-.065 3.97Z",
    opacity: 0.1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_shaded_sphere_dark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};
export default SvgIconShadedSphereDark;